import get from 'lodash/get';
import { GetServerSideProps } from 'next';
import * as React from 'react';

import { fetchPageContext, PageContextOptions } from 'core/services/context';
import { CommonPageContext, ReviewsPageContext } from 'core/services/context/context';
import { getQueryParamsWithUrl } from 'core/utils/filters/search-filter';

import { BlankPageStub } from 'components/common/blank-page-stub/blank-page-stub';

interface ReviewsPageProps {
  context: {
    common: CommonPageContext;
    extra: ReviewsPageContext;
  };
}

const ReviewsPage: React.FunctionComponent<ReviewsPageProps> = () => {
  return <BlankPageStub />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { res } = context;
  const host = process.env.NEXT_PUBLIC_MAIN_HOST || '';
  const correlationID = get(context, 'req.headers.x-request-id', '') as string;
  const cookies = get(context, 'req.headers.cookie', '');
  const accept = get(context, 'req.headers.accept', '');
  const query = getQueryParamsWithUrl(context);

  const options: PageContextOptions<ReviewsPageContext> = {
    path: '/',
    host,
    correlationID,
    cookies,
    authRequired: false,
    query,
    accept
    // extra: (accessToken: Optional<string>): Promise<ReviewsPageContext> => {
    //   // const centralContextService = new CentralContextService(host, correlationID, accessToken);
    //   // return centralContextService.fetchContext();
    // }
  };

  const pageContext = await fetchPageContext<ReviewsPageContext>(options);

  if (pageContext) {
    if (pageContext.common['set-cookie']) {
      pageContext.common['set-cookie'].map((cookie) => {
        res.setHeader('Set-Cookie', cookie);
      });
    }
  }

  return {
    props: {
      context: pageContext
    }
  };
};

export default ReviewsPage;
